module.exports = __webpack_public_path__ + "media/puerta_automatica/limitations-7ba2fcb7.png";